import PropTypes from 'prop-types';

export const ActivityProps = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string
});

export const ActivityDefaults = {
  id: 0,
  name: ''
};
